/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UserSettingsTag } from './UserSettingsTag';
/**
 * 차계부별 설정
 */
export type VehicleSetting = {
  /**
   * 차계부 Master ID
   */
  masterId: number;
  /**
   * 차량 모델 표시명
   */
  modelDisplayName: string;
  /**
   * 차량 등록번호
   */
  registrationNumber: string;
  /**
   * 차량 유류 타입. GASOLINE, GASOLINE HEV, GASOLINE PHEV, DIESEL, LPG, EV, PHEV, HYDROGEN 중 하나
   */
  fuelType: string;
  /**
   * 차량 식별번호
   */
  vin: string;
  /**
   * CCI 차량 사용자 주사용자 여부. true면 주사용자, false면 공유 사용자이며 CCI 차량 정보가 없으면 null
   */
  primaryUserYn: boolean;
  /**
   * 현재 사용자의 차계부 역할
   */
  role: VehicleSetting.role;
  /**
   * 차계부에 연결된 커스텀 태그 목록
   */
  tags: Array<UserSettingsTag>;
  /**
   * 수락된 공유 사용자 수
   */
  memberCount: number;
};
export namespace VehicleSetting {
  /**
   * 현재 사용자의 차계부 역할
   */
  export enum role {
    OWNER = 'OWNER',
    MEMBER = 'MEMBER',
  }
}

